import { IRequesterInfo } from '../../../../../base/models/proxyModels'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { SavePreOrderRequest, SavePreOrderResponse } from '../models/models'
export class CreatePreOrderService extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'order/createPreOrder', requesterInfo })
  }

  public async createPreOrder(request: SavePreOrderRequest): Promise<SavePreOrderResponse> {
    return await this.postAsync<SavePreOrderResponse>(request)
  }
}
